import { activeItems } from "./packageDetailRules";
import { ISpecialPackage, ISpecialServiceDetailItem } from "./patientSpecialPackage.interface";

/**
 * When the server would not take a group checkup selection, the patient's picks are kept for the
 * session and win over the server's `selected` everywhere (§10.3): the booking form's "Details" and
 * the `service_items` it sends.
 */
const storageKey = (packageKey: string) => `GROUP_EXAM_ITEMS_${packageKey}`;

export const saveLocalSelection = (packageKey: string, items: ISpecialServiceDetailItem[]) => {
  try {
    sessionStorage.setItem(storageKey(packageKey), JSON.stringify(items));
  } catch (error) {}
};

export const clearLocalSelection = (packageKey: string) => {
  try {
    sessionStorage.removeItem(storageKey(packageKey));
  } catch (error) {}
};

const loadLocalSelection = (packageKey: string): ISpecialServiceDetailItem[] | null => {
  try {
    const raw = sessionStorage.getItem(storageKey(packageKey));
    const parsed = raw ? JSON.parse(raw) : null;

    return Array.isArray(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
};

/** The chosen items of a group checkup: the session's picks, else what the server has selected, mandatory ones included. */
export const chosenGroupExamItems = (pkg: ISpecialPackage): ISpecialServiceDetailItem[] => {
  const local = pkg.key ? loadLocalSelection(pkg.key) : null;

  if (local) {
    return activeItems(local);
  }

  const holder = (pkg.patient_special_package_details ?? []).find((service) => activeItems(service.items).length > 0);

  return activeItems(holder?.items).filter((item) => item.selected || item.mandatory);
};

/** The catalogue with the session's picks applied, for a read-only recap. */
export const groupExamCatalogueView = (pkg: ISpecialPackage): ISpecialServiceDetailItem[] => {
  const holder = (pkg.patient_special_package_details ?? []).find((service) => activeItems(service.items).length > 0);
  const local = pkg.key ? loadLocalSelection(pkg.key) : null;
  const items = activeItems(holder?.items);

  if (!local) {
    return items;
  }

  const ids = local.map((item) => Number(item.id));

  return items.map((item) => ({ ...item, selected: ids.includes(Number(item.id)) }));
};

export const hasLocalSelection = (packageKey?: string) => !!packageKey && !!loadLocalSelection(packageKey);
